import { Http } from "../axios/interceptors";

export const allSubcriptions = async (param) =>
  Http("GET", `/Subscriptions/GetList?`, param);

export const getSubcription = async (guid) =>
  Http("GET", `/Subscriptions/Get?guid=${guid}`);

export const createOrEditSubcription = async (body, id = null) =>
  id
    ? Http("PUT", `/Subscriptions/Update`, null, body)
    : Http("POST", "/Subscriptions/Create", null, body);

export const deleteSubcription = async (guid) =>
  Http("DELETE", `/Subscriptions/Delete?guid=${guid}`);
